I18n.translations.ru.test = {
  resultIntro: 'Ответьте на все вопросы теста, <br class="device desktop laptop">чтобы узнать результат.',
  result: 'Результат',
  rerun: '↺ Пересдать',
  passed: 'Вы ответили правильно на все вопросы',
  failed: 'Вы ответили неправильно на все вопросы',
  resulted: {
    one: 'Вы ответили правильно на %{count} вопрос из %{total}',
    few: 'Вы ответили правильно на %{count} вопроса из %{total}',
    many: 'Вы ответили правильно на %{count} вопросов из %{total}',
    other: 'Вы ответили правильно на %{count} вопросов из %{total}',
  },
};

I18n.translations.en.test = {
  resultIntro: 'Answer all test questions <br class="device desktop laptop">to see the result.',
  result: 'Result',
  rerun: '↺ Retake',
  passed: 'You’ve answered all the questions correctly',
  failed: 'You’ve answered all the questions incorrectly',
  resulted: {
    one: 'You’ve correctly answered %{count} question out of %{total}',
    other: 'You’ve correctly answered %{count} questions out of %{total}',
  },
};
